import type { BillingInvoice, BoletoStatus } from '@/types/database';

export type { BillingInvoice, BoletoStatus };

export const BOLETO_STATUS_LABELS: Record<BoletoStatus, string> = {
  pending: 'Pendente',
  paid: 'Pago',
  overdue: 'Vencido',
  canceled: 'Cancelado',
};

export const BOLETO_STATUS_BADGE: Record<BoletoStatus, string> = {
  pending: 'bg-amber-100 text-amber-700 border-amber-200',
  paid: 'bg-green-100 text-green-700 border-green-200',
  overdue: 'bg-red-100 text-red-700 border-red-200',
  canceled: 'bg-gray-100 text-gray-600 border-gray-200',
};

export interface BoletoFilters {
  search: string;
  status: BoletoStatus | 'all';
  fromDate: string;
  toDate: string;
}

export const DEFAULT_BOLETO_FILTERS: BoletoFilters = {
  search: '',
  status: 'all',
  fromDate: '',
  toDate: '',
};

/** Calcula status efetivo: se pending e due_date < hoje, mostra como overdue. */
export function effectiveStatus(b: BillingInvoice): BoletoStatus {
  if (b.status !== 'pending') return b.status;
  const due = new Date(`${b.due_date}T23:59:59`);
  return due < new Date() ? 'overdue' : 'pending';
}
